import React from 'react';
import LegalFooter from './LegalFooter';

const AuthLayout = ({ title, description, titleRef, legalLinksNewTab = false, children }) => (
  <div className="min-h-screen bg-gray-50 px-4 py-6 sm:py-10">
    <header className="mx-auto mb-6 flex max-w-md items-center justify-center gap-2.5">
      <img src={`${process.env.PUBLIC_URL}/leadmarka_logo-color.svg`} alt="" className="h-8 w-8" />
      <span className="text-xl font-bold tracking-tight text-gray-900">LeadMarka</span>
    </header>
    <main className="mx-auto w-full max-w-md rounded-2xl border border-gray-200 bg-white p-5 shadow-sm sm:p-8" aria-labelledby="auth-heading">
      <h1 ref={titleRef} tabIndex={titleRef ? -1 : undefined} id="auth-heading" className="text-2xl font-bold text-gray-900">{title}</h1>
      <p className="mt-2 mb-6 text-sm leading-6 text-gray-600">{description}</p>
      {children}
    </main>
    <LegalFooter className="mx-auto mt-4 max-w-md" openInNewTab={legalLinksNewTab} />
  </div>
);

export default AuthLayout;
